import { render, staticRenderFns } from "./ProofworkSettings.vue?vue&type=template&id=64be30b3"
import script from "./ProofworkSettings.vue?vue&type=script&lang=js"
export * from "./ProofworkSettings.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports